import React from "react";

export default (props: React.SVGAttributes<SVGElement>) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M20 2H4C3 2 2 2.9 2 4V7.01C2 7.73 2.43 8.35 3 8.7V20C3 21.1 4.1 22 5 22H19C19.9 22 21 21.1 21 20V8.7C21.57 8.35 22 7.73 22 7.01V4C22 2.9 21 2 20 2ZM19 20H5V9H19V20ZM20 7H4V4H20V7Z" fill="black"/>
<path d="M3.41421 1.41421C3.149 1.149 2.78929 1 2.41421 1V1C1.63316 1 1 1.63316 1 2.41421V2.41421C1 2.78929 1.149 3.149 1.41421 3.41421L20.5858 22.5858C20.851 22.851 21.2107 23 21.5858 23V23C22.3668 23 23 22.3668 23 21.5858V21.5858C23 21.2107 22.851 20.851 22.5858 20.5858L3.41421 1.41421Z" fill="black"/>
<path d="M15 12H9V14H15V12Z" fill="black"/>
</svg>
;
